// The client error report (POST /api/client-errors): what the client sends when its own code fails, and the bounds
// both ends agree on. Why a report at all: app-baseline 05-client §5.2 — the correlation identifier the person sees
// must be "carried in the report the app sends to its own telemetry", so the detail exists in one place and the
// person's copy is a key to it. A server failure already meets that through the trace id; a rendering error has no
// request, so the client makes one (conformity finding D2; the owner's brief of 2026-10-05, group B).

// The kinds are a closed enum and so are declared in enums.ts (the one place, per this repository's CLAUDE.md); they are
// re-exported here so the report's two ends import one module for everything they share.
export { CLIENT_ERROR_KINDS, type ClientErrorKind } from './enums.js';

/**
 * The reference a boundary mints and shows (`ui-` plus eight hex digits). The server accepts nothing else as a
 * reference, so the log line can only ever be keyed by what a person was shown.
 */
export const CLIENT_ERROR_REFERENCE = /^ui-[0-9a-f]{8}$/u;

/**
 * Per-field bounds: the client truncates to them and the server refuses beyond them (05-client §5.2 — the report, not
 * the screen, carries the detail; a stack is useful to a few kilobytes and abusive beyond). `path` is the location's
 * pathname only, never its query or hash.
 */
export const CLIENT_ERROR_REPORT_LIMITS = Object.freeze({
  version: 32,
  message: 1000,
  stack: 4000,
  componentStack: 4000,
  path: 2000,
});

/** Cuts `text` to `max` characters, marking the cut so a reader knows the tail is missing. */
export function boundText(text: string, max: number): string {
  if (text.length <= max) return text;
  const marker = '…';
  return `${text.slice(0, Math.max(0, max - marker.length))}${marker}`;
}
